import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { res } from '../../common/language/text/res';
import { Strings } from '../../common/language/strings';
@Component({
  selector: 'app-combo-multi-select',
  templateUrl: './combo-multi-select.component.html',
  styleUrls: ['./combo-multi-select.component.css']
})

export class ComboMultiSelectComponent implements AfterContentInit{
    
  @Input() availableList: any[] = [];
  @Output() onChange = new EventEmitter<any>();
  @Input() selectedList: any[] = [];
  placeHolder = res.SelectAnOption;
  optionList: any[] = [];
  
  constructor(public strings: Strings){}
  
  ngAfterContentInit(): void {
    this.optionList = this.availableList;
  }
  
  handleInputChange($event) {
    this.onChange.emit(this.selectedList);
  }

  selectOption(selected: any[]){
    if (selected.length > 0) {
      this.optionList.forEach(item => {
        selected.forEach(element => {
          if (element == item) {
            this.selectedList.push(item) 
          }
        });
      });
    }
  }
}
